import React, { FC } from 'react'
import { MoonLoader } from 'react-spinners'
import { useTheme } from 'styled-components'

import DefaultLayout, { DefaultLayoutProps } from '../../layouts/DefaultLayout'
import TitleDescription, { TitleDescriptionProps } from '../../components/TitleDescription'

import * as SC from './styled'

export type LoaderTemplateProps = {
  className?: string
  layout?: DefaultLayoutProps
  titleDescription?: TitleDescriptionProps
}

const LoaderTemplate: FC<LoaderTemplateProps> = (props) => {
  const { layout, titleDescription } = props

  const theme = useTheme()

  return (
    <DefaultLayout {...layout}>
      <SC.Content>
        {titleDescription && <TitleDescription {...titleDescription} />}
        <MoonLoader color={theme.colors.pureBlack} size={28} />
      </SC.Content>
    </DefaultLayout>
  )
}

export default LoaderTemplate
